module.exports = __webpack_public_path__ + "media/web.21a30973.mp4";